<template>
  <screener-frame>
    <screener-title title="Health Symptoms" />

    <v-row>
      <v-col
        v-for="symptom in symptoms"
        :key="symptom.name"
        cols="12"
        md="6"
      >
        <common-toggle
          v-model="symptom.value"
          :label="symptom.label"
        />
      </v-col>
    </v-row>

    <template #actions>
      <v-spacer />

      <v-btn
        class="button-next"
        color="primary"
        to="/diagnoses"
      >
        Next
        <v-icon>mdi-chevron-double-right</v-icon>
      </v-btn>
    </template>
  </screener-frame>
</template>

<script>
import { symptoms } from '@/use/screener'

export default {
  setup: () => ({ symptoms })
}
</script>
